import BaseTable from '@tiptap/extension-table'

import { toggleHeader } from './commands.js'
import { TableView } from './table-view.js'

export const Table = BaseTable.extend({
  addOptions() {
    return {
      ...this.parent?.(),
      View: TableView,
    }
  },
  addAttributes() {
    return {
      ...this.parent?.(),
      class: {
        default: 'border-collapse m-0 table-fixed',
      },
    }
  },
  addCommands() {
    return {
      ...this.parent?.(),
      toggleHeaderColumn:
        () =>
        ({ state, dispatch }) => {
          return toggleHeader('column')(state, dispatch)
        },
      toggleHeaderRow:
        () =>
        ({ state, dispatch }) => {
          return toggleHeader('row')(state, dispatch)
        },
    }
  },
  addKeyboardShortcuts() {
    return {
      ...this.parent?.(),
      'Mod-Shift-D': () => this.editor.commands.deleteTable(),
    }
  },
})
